import { Box, Divider, Heading } from '@hover/blueprint';
import React, { FC } from 'react';
import { nanoid } from 'nanoid';
import { NEWS_PAGE_STATES } from '../../constants';
import DownloadButton from './DownloadButton';

interface Props {
  onClick: Function;
  state: string;
}

const Sidebar: FC<Props> = ({ onClick, state }) => (
  <Box w="100%" flexDir="column">
    <Divider color="neutral.300" opacity={1} my={0} />
    {Object.values(NEWS_PAGE_STATES).map(item => (
      <React.Fragment key={nanoid()}>
        <Box my={500} flexDir="column">
          <Heading
            as="h2"
            isLight
            cursor="pointer"
            onClick={() => {
              onClick(item);
            }}
            size={500}
            color={item === state ? 'primary.600' : 'neutral.900'}
            marginBottom="0!important"
          >
            {item}
          </Heading>
          {item === 'Media Kit' ? (
            <DownloadButton
              downloadLink="https://drive.google.com/drive/folders/1-zxRmGMRVLADvgOLfyekJX08ELhqy5Q5"
              description="Logos and brand assets are available for download."
            />
          ) : null}
        </Box>
        <Divider color="neutral.300" opacity={1} my={0} />
      </React.Fragment>
    ))}
  </Box>
);

export default Sidebar;
